export const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()

export const preventMoreThreeCharacters = (e) => (e.target.value.length >= 3 && e.key !== "Backspace") && e.preventDefault()